// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main-footer{-ms-flex-negative:0;flex-shrink:0}main-footer .link{color:#fff;font-weight:700;opacity:.75;display:inline}main-footer span{display:block;opacity:.75;margin-bottom:1rem}main-footer .link:after{content:\"|\";margin:0 .3rem}main-footer .link:last-child:after{content:\"\";margin:0}", ""]);
// Exports
module.exports = exports;
